<!-- Free-text search, applied server-side so the badges below honour it. Matches customer number,
     customer name, synchronization name, beskrivelse and handling — but not the company alias, which
     is the one field that would need a per-tenant lookup on every keystroke. -->
<div class="input-group input-group-sm mb-2">
    <span class="input-group-text bg-transparent border-end-0">
        <i class="fa-solid fa-magnifying-glass text-secondary" aria-hidden="true"></i>
    </span>
    <input type="search" class="form-control border-start-0 ps-0"
        placeholder="Søg kunde, synkronisering, beskrivelse …"
        aria-label="Søg i kørsler"
        [value]="query().search"
        (input)="onSearchChange($any($event.target).value)">
    @if (query().search) {
        <button type="button" class="btn btn-outline-secondary" (click)="clearSearch()"
            aria-label="Ryd søgning">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
    }
</div>

<!-- Time window: three rolling spans plus a single-day picker -->
<div class="mb-2">
    <div class="btn-group btn-group-sm count-filter-group w-100 mt-1" role="group" aria-label="Tidsrum">
        <!-- Anchor + explicit toggle() so the click handler stays ours. Both anchor and toggle set
             .dropdown-toggle, so the Bootstrap caret is suppressed below — no room for it beside
             the badge. -->
        <div class="btn-group" role="group" ngbDropdown #dayDropdown="ngbDropdown"
            placement="bottom-start" container="body">
            <button type="button" class="btn position-relative time-filter-day"
                [class.active]="query().window === 'day'"
                ngbDropdownAnchor (click)="dayDropdown.toggle()">
                {{ dayFilterLabel() }}
                <span class="count-badge">{{ dayCountLabel() }}</span>
            </button>
            <div ngbDropdownMenu class="p-0">
                <!-- navigation="none" both drops controls that cannot go anywhere useful across a
                     7-day range, and makes the datepicker label each month — without it the grid
                     shows bare day numbers with no month at all. -->
                <ngb-datepicker [minDate]="minPickableDay" [maxDate]="maxPickableDay"
                    [startDate]="minPickableDay" [displayMonths]="pickerMonths"
                    navigation="none"
                    (dateSelect)="pickDay($event); dayDropdown.close()">
                </ngb-datepicker>
            </div>
        </div>

        @for (window of timeWindows; track window.key) {
            <button type="button" class="btn position-relative"
                [class]="'time-filter-' + window.key"
                [class.active]="query().window === window.key"
                (click)="setWindow(window.key)">
                {{ window.label }}
                <span class="count-badge">{{ windowCounts()[window.key] }}</span>
            </button>
        }
    </div>
</div>

<!-- Status group. The counts never respect this filter — they have to show what you could switch to. -->
<div>
    <div class="btn-group btn-group-sm count-filter-group w-100 mt-1" role="group" aria-label="Status">
        @for (group of statusGroups; track group.key) {
            <button type="button" class="btn position-relative"
                [class]="(query().statusGroup === group.key ? 'btn-' : 'btn-outline-') + group.btnClass"
                (click)="setStatusGroup(group.key)">
                {{ group.label }}
                <span class="count-badge">{{ countFor(group.key) }}</span>
            </button>
        }
    </div>
</div>
